<template>
    <div class="fullbooking">
        <FullBookingComponent></FullBookingComponent>
    </div>
</template>


<script>
    import FullBookingComponent from '@/components/cust_components/cust_booking_details_component.vue';

    export default {
        name: 'fullBooking',
        data() {
            return {
            }
        },
        components: {
            FullBookingComponent
        }

    }
</script>